import React from 'react';
import './LoadingSpinner.css'; // Creeremo questo file CSS

const LoadingSpinner = ({ fullPage = false }) => {
    if (fullPage) {
        return (
            <div className="spinner-overlay">
                <div className="spinner"></div>
            </div>
        );
    }
    // Spinner in linea (per tabelle, ecc.)
    return <div className="spinner-inline"></div>;
};

export default LoadingSpinner;